module.exports = __webpack_public_path__ + "static/media/convention-2.c7dafc51.webp";